<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M16 13V10.75C16 9.92155 15.3284 9.25 14.5 9.25C13.6716 9.25 13 9.92155 13 10.75V11.5H7V10.75C7 9.92155 6.32843 9.25 5.5 9.25C4.67157 9.25 4 9.92155 4 10.75V13C4 13.8284 4.67157 14.5 5.5 14.5H14.5C15.3284 14.5 16 13.8284 16 13Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M14.5 9.25V5.5C14.5 4.67157 13.8284 4 13 4H7C6.17157 4 5.5 4.67157 5.5 5.5V9.25"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5.5 14.5V16"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M14.5 14.5V16"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    /></svg>
</template>

<script>
export default {
  name: 'ChairIcon',
  props: {
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    }
  }
}
</script>

<style scoped></style>
